import { SVGProps } from 'react';
import SVG from '.';
import { SVGIconFilterAlphabeticalCrescent } from './SVGIconFilterAlphabeticalCrescent';
import { SVGIconFilterAlphabeticalDecrescent } from './SVGIconFilterAlphabeticalDecrescent';

export default Object.assign(
  ({ children, ...rest }: SVGProps<any>) => {
    return <SVG.Icon.Filter {...rest}>{children}</SVG.Icon.Filter>;
  },
  {
    Crescent: SVGIconFilterAlphabeticalCrescent,
    Decrescent: SVGIconFilterAlphabeticalDecrescent,
  },
);
